import React from 'react'
import Request from './request'
import Assignment from './assignment'

class Component extends React.Component {
    render() {
        var searchParams = new URLSearchParams(this.props.location.search)
        var keyParam = searchParams.get('token')

        if (!keyParam) return <Request {...this.props} />
        return <Assignment {...this.props} keyParam={keyParam} />
    }
}

export default Component
